module.exports = require("@seddi/three/addons/utils/BufferGeometryUtils.js");